import { request } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

// Root dentro do sistema de um escritório: a sessão dele fica guardada e volta ao sair.
const CHAVE = 'user_root'

const lerUsuario = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null') } catch { return null }
}

export const acessoRootAtual = () => lerUsuario()?.acessoRoot || null

export function entrarNaEmpresa(dados) {
  localStorage.setItem(CHAVE, localStorage.getItem('user') || '')
  localStorage.setItem('user', JSON.stringify(dados))
  cacheClear()
  window.location.assign('/dashboard')
}

export function restaurarRoot() {
  const salvo = localStorage.getItem(CHAVE)
  if (!salvo) return false
  localStorage.setItem('user', salvo)
  localStorage.removeItem(CHAVE)
  cacheClear()
  return true
}

export const esquecerRoot = () => localStorage.removeItem(CHAVE)

export async function sairDaEmpresa() {
  await request.post('/company/encerrar-acesso').catch(() => undefined)
  restaurarRoot()
  window.location.assign('/plataforma-admin')
}
